const headerContainer = document.getElementById('header');
const body = document.body;
const SCROLL_OFFSET = 160;

if (headerContainer) {
  var lastScrollTop = 0;
  var expandHeaderScroll = 0;

  window.addEventListener('scroll', function () {
    var scrollTop = document.documentElement.scrollTop;
    if (
      scrollTop > lastScrollTop &&
      scrollTop > SCROLL_OFFSET &&
      !body.classList.contains('navigation-megamenu-opened') &&
      !body.classList.contains('account-popover-opened')
    ) {
      //Scrolled down
      body.classList.add('scrolled');
    } else if (scrollTop < lastScrollTop) {
      //scrolled up
      body.classList.remove('scrolled');
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
}
